import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import pluralize from 'rebook/apps/utils/text/pluralize';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';

import styles from './style.scss';


const SimilarAuthorHorizontalCard = (props) => {
  const { cover_name: coverName, active_book_count: activeBookCount, photo, absolute_url: absoluteUrl } = props.author;
  return (
    <div className={classNames('swiper-slide', styles.item)}>
      <Link to={absoluteUrl}>
        <div className={styles.image}>
          <CroppedImage
            src={photo}
            width="112"
            height="112"
            alt={coverName} />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <MultilineEllipsisText maxLinesCount={2}>
              {coverName}
            </MultilineEllipsisText>
          </div>
          <div className={styles.amount}>
            <span className={styles.authorAmount}>
              {activeBookCount} {pluralize(activeBookCount, 'книга', 'книги', 'книг')}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

SimilarAuthorHorizontalCard.propTypes = {
  author: PropTypes.shape({
    cover_name: PropTypes.string.isRequired,
    active_book_count: PropTypes.number.isRequired,
    photo: PropTypes.string,
    absolute_url: PropTypes.string.isRequired,
  }).isRequired,
};

export default SimilarAuthorHorizontalCard;
